<template>
  <div style="justify-items: center;">
    <v-container class="ma-0 pa-0">
      <v-row class="pa-0 ma-0">
        <v-col cols="12">
          <div @click="viewDocument" class="custom-btn primary--text outlined-border">
            <v-icon small color="primary">
              mdi-eye
            </v-icon>
            Visualizar {{ label }}
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="dialog"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDocument">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>
            Visualización de {{ clearStrings(label) }}
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn
            text
            dark
            @click="nuevaPestana(getURL())"
          >
            <v-icon left>
              mdi-download
            </v-icon>
            Descargar Documento
          </v-btn>
        </v-toolbar>

        <v-row class="pa-0 ma-0">
          <v-col cols="12" v-if="showPDF">
            <div class="pdf-container">
              <!-- Indicador de carga -->
              <div v-if="loading" class="text-center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="200"
                  :width="7"
                />
                <div class="mt-4 text-h6">Cargando documento...</div>
              </div>

              <vue-pdf-embed
                :key="'pdf-' + viewerKey"
                class="pdf-viewer"
                :source="url"
                @rendered="onPdfRendered"
                @rendering-failed="onPdfError"
              />
            </div>
          </v-col>

          <v-col v-else cols="12" style="position: relative;">
            <!-- Indicador de carga para imágenes -->
            <div v-if="loading" class="loading-overlay">
              <v-progress-circular
                indeterminate
                color="primary"
                :size="70"
                :width="7"
              />
              <div class="loading-text mt-4">Cargando imagen...</div>
            </div>

            <v-img
              :key="'img-' + viewerKey"
              :src="url"
              contain
              max-height="85vh"
              @load="onImageLoaded"
              @error="onImageError"
            />
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  name: "DownloadButtonWithTextarea",
  components: {
    'vue-pdf-embed': VuePdfEmbed,
  },
  props: {
    value: {
      type: [String],
      default: null
    },
    urlBase: {
      type: String,
      required: true,
      default: '/api/Proveedores/DescargarDocumento'
    },
    label: {
      type: String,
      default: ''
    },
    ignoreFormat: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      file: null,
      dialog: false,
      url: null,
      showPDF: false,
      loading: false,
      viewerKey: 0, // <-- fuerza remount para evitar “documento anterior”
    };
  },
  computed: {
    isDownloadable() {
      return this.value && typeof this.value === 'string' && (this.file == null);
    },
    fileUrl() {
      // Nota: aquí tenías un formato distinto (sin '/'), lo dejo igual que tu lógica original
      return (this.isDownloadable || this.ignoreFormat)
        ? `${this.urlBase}${this.value}?jwt=${this.$store.state.token}`
        : null;
    }
  },
  watch: {
    // Si se cierra por ESC/click afuera/etc, limpia todo
    dialog(val) {
      if (!val) {
        this.closeDocument();
      }
    }
  },
  methods: {
    downloadFile() {
      if (this.fileUrl) {
        window.open(this.fileUrl, '_blank');
      }
    },

    viewDocument() {
      // Limpia primero para que no se pinte lo anterior
      this.loading = true;
      this.url = null;

      // Decide si es PDF
      this.showPDF = this.isPdfFile(this.value);

      // Fuerza destrucción del visor anterior
      this.viewerKey++;

      // Abre dialog y asigna URL en el siguiente tick
      this.dialog = true;

      this.$nextTick(() => {
        this.url = this.getURL();
        // console.log(this.url);
      });
    },

    closeDocument() {
      // Ojo: si este método es llamado por el watcher al cerrar,
      // podría entrar aquí con dialog ya en false, no pasa nada.
      this.dialog = false;

      // Fuerza remount (destruye el embed/img)
      this.viewerKey++;

      // Limpia estado
      this.url = null;
      this.showPDF = false;
      this.loading = false;
    },

    onPdfRendered() {
      this.loading = false;
    },
    onPdfError(error) {
      console.error('Error al cargar el PDF:', error);
      this.loading = false;
    },

    onImageLoaded() {
      this.loading = false;
    },
    onImageError(error) {
      console.error('Error al cargar la imagen:', error);
      this.loading = false;
    },

    clearFile() {
      this.$emit('input', null);
      this.file = null;
    },
    handleFileChange() {
      if (this.file) {
        console.log(this.file);
        this.$emit('input', this.file);
      }
    },

    isPdfFile(fileName) {
      if (this.ignoreFormat) return true;

      if (!fileName) return false;

      let name = fileName;
      if (name.endsWith('.enc')) {
        name = name.slice(0, -4);
      }

      return name.toLowerCase().endsWith('.pdf');
    },

    clearStrings(inputString) {
      return (inputString || '').replace(/ \*/g, '');
    },

    getURL() {
      // Este era tu formato original (con '/')
      return `${this.urlBase}/${this.value}?jwt=${this.$store.state.token}`;
    },
    nuevaPestana(url) {
      window.open(url, "_blank");
    },
  }
};
</script>

<style scoped>
.custom-btn {
  display: inline-block;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  font-weight: 500;
  white-space: normal;
  width: 100%;
  line-height: 1.2em;
  background-color: transparent;
}

/* Aplica el borde outlined con el color primario de Vuetify */
.outlined-border {
  border: 1px solid;
  border-color: var(--v-primary-base);
}

.pdf-container {
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 8px;
  max-height: 85vh;
  overflow: auto;
  position: relative;
}

.pdf-viewer {
  width: 100%;
  height: calc(100% - 32px);
  max-height: 100%;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 10;
  border-radius: 8px;
}

.loading-text {
  color: #666;
  font-size: 16px;
  font-weight: 500;
}
</style>
